import React from "react";

export default function ToolbarObject({ found, src }) {
	return (
		<div className='found_object' found={found}>
			<img src={src} alt='' />
		</div>
	);
}
